import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=3d51124f&scoped=true&"
import script from "./Recognition.vue?vue&type=script&lang=ts&"
export * from "./Recognition.vue?vue&type=script&lang=ts&"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=3d51124f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51124f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d51124f', component.options)
    } else {
      api.reload('3d51124f', component.options)
    }
    module.hot.accept("./Recognition.vue?vue&type=template&id=3d51124f&scoped=true&", function () {
      api.rerender('3d51124f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/Recognition.vue"
export default component.exports